import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function CloseSection() {
  return <section className="bg-[#2D2D2D] px-4 py-14 sm:px-6 lg:px-8 lg:py-20 text-white" data-id="element-12">
      <div className="mx-auto max-w-3xl text-center" data-id="element-13">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="space-y-8 font-sans text-xl leading-loose text-white/90" data-id="element-14">
          <p className="font-serif text-3xl font-bold text-[#FBF7F0]" data-id="element-15">
            You picked up this letter because something in you recognized it.
          </p>

          <p data-id="element-16">
            The exhaustion. The invisibility. The grief of losing yourself
            inside a role you love.
          </p>
          <p className="font-serif text-2xl italic text-[#E8A838]" data-id="element-17">
            You love your baby. And you miss yourself. Both things are true.
          </p>
          <p data-id="element-18">
            The mothers who feel most present, most joyful, most alive in
            motherhood are not the ones who sacrificed everything. They're the
            ones who understood that you cannot pour from empty — and chose
            themselves too.
          </p>
          <p className="font-bold text-[#FBF7F0]" data-id="element-19">
            That's not selfish. That's sustainable.
          </p>
          <p data-id="element-20">That's what Back To You is built for.</p>
          <p data-id="element-21">
            In 90 days, you will put on the dress that right now feels like a
            fantasy.
          </p>

          <div className="my-8 py-6 border-y border-white/10" data-id="element-22">
            <p className="font-serif text-3xl font-bold text-[#FBF7F0] mb-6" data-id="element-23">
              But that moment won't feel like a number on a scale.
            </p>
            <p className="font-serif text-4xl italic text-[#D4603A] mb-8" data-id="element-24">
              It will feel like recognition.
            </p>
            <p className="font-serif text-3xl text-[#FBF7F0]" data-id="element-25">
              Like looking in the mirror and finally seeing her again.
            </p>
          </div>

          <p data-id="element-26">Not the woman you were before — something better. Version 2.0.</p>
          <p data-id="element-27">
            Stronger. More grounded. More herself. A mother who didn't disappear
            into the role — she expanded because of it.
          </p>

          <p className="font-serif text-4xl font-bold text-[#E8A838] my-8" data-id="element-28">
            She was always in there. You're just choosing her now.
          </p>

          <div id="cta-final" className="mt-10 flex flex-col items-center gap-6" data-id="element-29">
            <div className="mb-2 flex flex-col items-center gap-1" data-id="element-30">
              <span className="font-sans text-lg text-white/50 line-through" data-id="element-31">
                $19.99
              </span>
              <span className="font-serif text-5xl font-bold text-[#E8A838]" data-id="element-32">
                $6.36
              </span>
              <span className="font-sans text-sm font-semibold uppercase tracking-widest text-[#81B29A]" data-id="element-33">
                Special price — 68% off
              </span>
            </div>
            <CTAButton text="YES — I'm Ready To Come Back To Me" href="https://coresolutionsg.com/cart/47510303932603:1" className="w-full sm:w-auto text-xl py-6 px-10" data-id="element-34" />
            <p className="font-sans text-sm tracking-wide text-white/60 uppercase" data-id="element-35">
              Get instant access to the complete Back To You Method
            </p>
            <p className="mt-4 font-serif text-xl italic text-[#81B29A]" data-id="element-36">
              Your baby deserves a happy mother. But first — you deserve
              yourself.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}